// Import Img
import Img1 from "../../assets/img/volunteer/volunteer-1.png"
import Img2 from "../../assets/img/volunteer/volunteer-2.png"
import Img3 from "../../assets/img/volunteer/volunteer-3.png"
import Img4 from "../../assets/img/volunteer/volunteer-4.png"
import img5 from "../../assets/img/volunteer/volunteer-5.png"
import Img6 from "../../assets/img/volunteer/volunteer-6.png"
import Img7 from "../../assets/img/volunteer/volunteer-7.png"
import Img8 from "../../assets/img/volunteer/volunteer-8.png"

export const TeamDatas = [
 
    {
        img:Img1,
        name:"Amina Rahman",
        title:"Board chair"
    },
    {
        img:Img2,
        name:"Omar Siddiqui",
        title:"Badminton & seasonal sports"
    },
    {
        img:Img3,
        name:"Sana Malik",
        title:"Education & integration lead"
    },
    {
        img:Img4,
        name:"Hassan Iqbal",
        title:"Youth programmes"
    },
    {
        img:img5,
        name:"Nadia Farooq",
        title:"Culture & social events"
    },
    {
        img:Img6,
        name:"Imran Saleem",
        title:"Badminton head coach"
    },
    {
        img:Img7,
        name:"Leila Yusuf",
        title:"Volunteer coordinator"
    },
    {
        img:Img8,
        name:"Danish Ali",
        title:"Communications"
    }

  ]

